export enum OrderColumnKey {
  Id = 'id',
  CustomerId = 'customerId',
  CustomerFirstName = 'customerFirstName',
  CustomerLastName = 'customerLastName',
  CustomerEmail = 'customerEmail',
  CreationDate = 'creationDate',
  OrderStatus = 'orderStatus',
  DeliveryType = 'deliveryType',
  Creator = 'creator',
  CanEditData = 'canEditData',
  Actions = 'actions',
}
